import { FC } from 'react';

export const CheckedIcon: FC<React.HTMLAttributes<HTMLOrSVGElement>> = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
    <path d="M16.6666 5L7.49998 14.1667L3.33331 10" stroke="#195AFF" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);
